import { FlatInteractionModelData } from 'types/shared'

export default function getValuesFromBaseInteraction(
  currentFlatData: FlatInteractionModelData | undefined,
  baseFlatData: FlatInteractionModelData
): FlatInteractionModelData | undefined {
  if (!currentFlatData) return undefined

  const matchedData: FlatInteractionModelData = { ...currentFlatData }

  // Match activity values
  if (currentFlatData.activity_values && baseFlatData.activity_values) {
    matchedData.activity_values = {}
    for (const key in baseFlatData.activity_values) {
      if (key in currentFlatData.activity_models) {
        matchedData.activity_values[key] = baseFlatData.activity_values[key]
      }
    }
  }

  return matchedData
}
